import { useRef, useState, useEffect } from 'react';

const useSwipe = (element, events, options = {
  sensitivity: 50,
  sensitivityPreventPropagation: Infinity,
  disabled: false
}) => {
  const startX = useRef(0);
  const startY = useRef(0);
  const endX = useRef(0);
  const endY = useRef(0);
  const [dragging, setDragging] = useState(false);
  const [willSwipe, setWillSwipe] = useState(false);
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);
  const touchUpOffsetX = useRef(0);
  const touchUpOffsetY = useRef(0);
  useEffect(() => {
    if (options.disabled || !element || !options.sensitivity) return;
    const handleTouchStart = (event) => {
      startX.current = event.touches[0].clientX;
      startY.current = event.touches[0].clientY;
      endX.current = event.touches[0].clientX;
      endY.current = event.touches[0].clientY;
      setOffsetX(0);
      setOffsetY(0);
      setDragging(true);
      setWillSwipe(true);
    };
    const handleTouchMove = (event) => {
      if (!dragging || !options.sensitivity) return;
      endX.current = event.touches[0].clientX;
      endY.current = event.touches[0].clientY;
      const offsetX2 = endX.current - startX.current;
      const offsetY2 = endY.current - startY.current;
      setOffsetX(offsetX2);
      setOffsetY(offsetY2);
      touchUpOffsetX.current = offsetX2;
      touchUpOffsetY.current = offsetY2;
      if (Math.abs(offsetX2) > options.sensitivity || Math.abs(offsetY2) > options.sensitivity) {
        setWillSwipe(true);
      } else {
        setWillSwipe(false);
      }
    };
    const handleTouchEnd = (e) => {
      if (!dragging) return;
      setDragging(false);
      setWillSwipe(false);
      if (!options.sensitivity) return;
      const horizontalSwipeAmount = startX.current - endX.current;
      const verticalSwipeAmount = startY.current - endY.current;
      const offsetX2 = endX.current - startX.current;
      const offsetY2 = endY.current - startY.current;
      touchUpOffsetX.current = offsetX2;
      touchUpOffsetY.current = offsetY2;
      setOffsetX(0);
      setOffsetY(0);
      if (options.sensitivityPreventPropagation && (Math.abs(offsetX2) > options.sensitivityPreventPropagation || Math.abs(offsetY2) > options.sensitivityPreventPropagation)) {
        e.stopPropagation();
        e.preventDefault();
      }
      if (Math.abs(horizontalSwipeAmount) < options.sensitivity && Math.abs(verticalSwipeAmount) < options.sensitivity) {
        return;
      }
      if (horizontalSwipeAmount > 0) {
        events.onSwipeLeft?.();
      } else {
        events.onSwipeRight?.();
      }
      if (verticalSwipeAmount > 0) {
        events.onSwipeUp?.();
      } else {
        events.onSwipeDown?.();
      }
    };
    element.addEventListener("touchstart", handleTouchStart);
    element.addEventListener("touchmove", handleTouchMove);
    element.addEventListener("touchend", handleTouchEnd);
    return () => {
      element.removeEventListener("touchstart", handleTouchStart);
      element.removeEventListener("touchmove", handleTouchMove);
      element.removeEventListener("touchend", handleTouchEnd);
    };
  }, [
    options.disabled,
    element,
    events,
    options.sensitivity,
    options.sensitivityPreventPropagation,
    dragging
  ]);
  useEffect(() => {
    if (!options.disabled) return;
    setDragging(false);
    setOffsetX(0);
    setOffsetY(0);
  }, [
    options.disabled
  ]);
  return {
    offsetX,
    offsetY,
    touchUpOffsetX,
    touchUpOffsetY,
    dragging,
    willSwipe
  };
};

export { useSwipe as default };
//# sourceMappingURL=useSwipe.js.map
